import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import swal from "sweetalert";
import ClipLoader from "react-spinners/ClipLoader";
import { API } from "../../../../API";
import { isAutheticated } from "../../../auth/authhelper";
import DatePicker from "react-datepicker";
import Footer from "../../Footer";

export default function Editsubject() {
  const [data, setData] = useState({
    title: "",
    banner: "",
    category: "",
    startDate: new Date(),
    endDate: new Date(),
  });
  const [fetchedData, setFetchedData] = useState([]);
  const [formData, setFormData] = useState(new FormData());
  const [loadingCategory, setLoadingCategory] = useState(false);
  const [loadingBanner, setLoadingBanner] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const { subjectId } = useParams();
  const history = useHistory();
  const { token } = isAutheticated();

  const wordLimit = {
    title: 50,
  };
  const [titleLen, setTitleLen] = useState(wordLimit.title);



  useEffect(() => {
    setLoadingBanner(true);
    axios
      .get(`${API}/api/banner/view_id/${subjectId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setData({
          title: response.data.data.title,
          banner: response.data.data.bannerimage,
          category: response.data.data?.category,
          startDate: new Date(response.data.data?.startdate),
          endDate: new Date(response.data.data?.enddate),
        });
        formData.set("name", response.data.data.title);
        setTitleLen(wordLimit.title - response.data.data.title.length);
      })
      .catch((err) => {
        console.error("Error fetching banner:", err);
        history.push("/subjects");
      })
      .finally(() => {
        setLoadingBanner(false);
      });
  }, [token, subjectId, history, formData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "file") {
      formData.set(name, e.target.files[0]);
      setData({ ...data, banner: URL.createObjectURL(e.target.files[0]) });
    } else {
      setData({ ...data, [name]: value });
      formData.set(name, value);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setLoadingSubmit(true);
    axios
      .patch(`${API}/api/banner/edit_banner/${subjectId}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(() => {
        swal({
          title: "Banner updated Successfully!",
          icon: "success",
          buttons: true,
        }).then(() => {
          history.push("/subjects");
        });
      })
      .catch((err) => {
        console.error("Error updating banner:", err);
        swal({
          title: "Error",
          text: err.response?.data?.message || "Something went wrong",
          icon: "error",
          buttons: true,
        });
      })
      .finally(() => {
        setLoadingSubmit(false);
      });
  };

  const handleEdit = (e, type) => {
    const length = e.target.value.length;
    if (type === "title" && wordLimit.title - length !== -1) {
      handleChange(e);
      setTitleLen(wordLimit.title - length);
    }
  };

  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-0">Content Management - Banners</h4>
                <div className="page-title-right">
                  <ol className="breadcrumb m-0">
                    <li className="breadcrumb-item">
                      <Link to="/">SoComOTT</Link>
                    </li>
                    <li className="breadcrumb-item">
                      Content Management - Banners
                    </li>
                    <li className="breadcrumb-item">Edit Banner</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12 col-lg-6 col-xl-6">
                      <h1 className="text-left head-small">Edit Banner</h1>
                      {loadingCategory || loadingBanner ? (
                        <div className="text-center">
                          <ClipLoader size={50} />
                          <p>Loading...</p>
                        </div>
                      ) : (
                        <form>
                          <div className="row">
                            <div className="col-lg-12">
                              <div className="form-group">
                                <label className="label-100">
                                  Enter Title Name<span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control input-field"
                                  name="title"
                                  value={data.title}
                                  onChange={(e) => handleEdit(e, "title")}
                                />
                                <p className="pt-1 pl-2 text-secondary">
                                  Remaining words : {titleLen}
                                </p>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-lg-12">
                              <div className="form-group">
                                <label className="label-100">
                                  Upload Banner Image(1260x500 px)<span className="text-danger">*</span>
                                </label>
                                <input
                                  type="file"
                                  className="form-control"
                                  name="file"
                                  onChange={handleChange}
                                />
                                <img
                                  className="img-fluid mt-2"
                                  style={{
                                    height: "125px",
                                    width: "274px",
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}
                                  alt="Preview"
                                  src={data.banner}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-lg-12">
                              <div className="form-group">
                                <label
                                  htmlFor="basicpill-phoneno-input"
                                  className="label-100"
                                >
                                  Select Page<span className="text-danger">*</span>
                                </label>
                                <select
                                  className="form-control input-field"
                                  name="category"
                                  value={data?.category}
                                  onChange={handleChange}
                                >
                                  <option value="">Select</option>
                                  <option value="Home">Home</option>
                                  <option value="Videos">Videos</option>
                                  <option value="Shop">Shop</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-lg-12">
                              <div className="form-group">
                                <label
                                  htmlFor="basicpill-phoneno-input"
                                  className="label-100"
                                >
                                  Start Date<span className="text-danger">*</span>
                                </label>
                                <div className="input-group">
                                  <DatePicker
                                    selected={data.startDate}
                                    required
                                    name="startdate"
                                    minDate={new Date()} // Prevent past dates
                                    onChange={(date) => {
                                      setData({
                                        ...data,
                                        startDate: date,
                                        endDate: date > data.endDate ? date : data.endDate, // Adjust endDate if needed
                                      });
                                      formData.set("startdate", date.toISOString());
                                    }}
                                    className="form-control"
                                  />
                                  <div className="input-group-append">
                                    <span className="input-group-text">
                                      <i
                                        className="fa fa-calendar"
                                        aria-hidden="true"
                                      ></i>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-lg-12">
                              <div className="form-group">
                                <label
                                  htmlFor="basicpill-phoneno-input"
                                  className="label-100"
                                >
                                  End Date<span className="text-danger">*</span>
                                </label>
                                <div className="input-group">
                                  <DatePicker
                                    selected={data.endDate}
                                    required
                                    name="enddate"
                                    minDate={data.startDate || new Date()} // Prevent dates before startDate
                                    onChange={(date) => {
                                      setData({
                                        ...data,
                                        endDate: date,
                                      });
                                      formData.set("enddate", date.toISOString());
                                    }}
                                    className="form-control"
                                  />
                                  <div className="input-group-append">
                                    <span className="input-group-text">
                                      <i
                                        className="fa fa-calendar"
                                        aria-hidden="true"
                                      ></i>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-lg-12">
                              <div className="form-group text-left">
                                <button
                                  type="button"
                                  className="btn btn-success btn-login waves-effect waves-light mr-3"
                                  onClick={onSubmit}
                                >
                                  <ClipLoader loading={loadingSubmit} size={18} />
                                  {!loadingSubmit && "Save"}
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
